import { Appender, LogEvent, LogLevel } from "../logger";

const levelColors: Record<string, string> = {
  DEBUG: "#4caf50",
  INFO: "#cfd8dc",
  WARN: "#ff9800",
  ERROR: "#ff3d00",
};

const LevelTypeStr: Record<LogLevel, string> = {
  [LogLevel.LEVEL_DEBUG]: "debug",
  [LogLevel.LEVEL_INFO]: "info",
  [LogLevel.LEVEL_WARN]: "warn",
  [LogLevel.LEVEL_ERROR]: "error",
};

export class ConsoleAppender extends Appender {
  append(e: LogEvent) {
    const levelStr: string = LevelTypeStr[e.level];
    const levelUp = levelStr.toLocaleUpperCase();
    const formattedDate = e.time
      .toTimeString()
      .replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");

    const prefixColored = e.tag
      ? `%c[${formattedDate}] [${levelUp}] [${e.tag}]`
      : `%c[${formattedDate}] [${levelUp}]`;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (console as any)[levelStr].apply(console, [
      `${prefixColored} ${e.message}`,
      `color:${levelColors[levelUp]}`,
      ...e.args,
    ]);
  }
}
